<template>
  <div class="main-content-box">
    <div class="main-content">
      <div class="main-title">联系我们</div>
      <div class="main-btn">
        <span class="btn-add" @click="addLink('contactus')">追加项</span>
      </div>
      <div class="from">
        <div class="row">
          <template v-for="(line,key1) in valueArr.contactus.data">
            <div class="row-box" :key="key1">
              <div class="title name">中文姓名</div>
              <input type="text" placeholder="请输入中文姓名" v-model.trim="line.name_zh">
              <div class="title name">英文姓名</div>
              <input type="text" placeholder="请输入英文姓名" v-model.trim="line.name_en">
              <div class="title job">学院</div>
              <input type="text" placeholder="请输入学院" v-model.trim="line.school">
              <div class="title job">职务</div>
              <input type="text" placeholder="请输入职务" v-model.trim="line.position">
              <img class="del" @click="del('contactus',key1)" src="@/assets/user_works_del_icon.png">
            </div>
          </template>
        </div>
      </div>
    </div>
    <!--
    <div class="main-content">
      <div class="main-title">大赛专委会</div>
      <div class="main-btn">
        <span class="btn-add" @click="addLink('expert_committee')">追加项</span>
      </div>
      <div class="from">
        <div class="row">
          <template v-for="(line,key1) in valueArr.expert_committee.data">
            <div class="row-box" :key="key1">
              <div class="title name">中文姓名</div>
              <input type="text" placeholder="请输入中文姓名" v-model.trim="line.name_zh">
              <div class="title name">英文姓名</div>
              <input type="text" placeholder="请输入英文姓名" v-model.trim="line.name_en">
              <div class="title job">学院</div>
              <input type="text" placeholder="请输入学院" v-model.trim="line.school">
              <div class="title job">职务</div>
              <input type="text" placeholder="请输入职务" v-model.trim="line.position">
              <img class="del" @click="del('expert_committee',key1)" src="@/assets/user_works_del_icon.png">
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="main-title">大赛执委会</div>
      <div class="main-btn">
        <span class="btn-add" @click="addLink('executive_committee')">追加项</span>
      </div>
      <div class="from">
        <div class="row">
          <template v-for="(line,key1) in valueArr.executive_committee.data">
            <div class="row-box" :key="key1">
              <div class="title name">中文姓名</div>
              <input type="text" placeholder="请输入中文姓名" v-model.trim="line.name_zh">
              <div class="title name">英文姓名</div>
              <input type="text" placeholder="请输入英文姓名" v-model.trim="line.name_en">
              <div class="title job">学院</div>
              <input type="text" placeholder="请输入学院" v-model.trim="line.school">
              <div class="title job">职务</div>
              <input type="text" placeholder="请输入职务" v-model.trim="line.position">
              <img class="del" @click="del('executive_committee',key1)" src="@/assets/user_works_del_icon.png">
            </div>
          </template>
        </div>
      </div>
    </div>
    -->
    <div class="btn-box">
      <span class="btn-confirm" @click="edit">保存</span>
    </div>
  </div>
</template>

<script>
import {getConfigInfo,editConfig} from "@/request/api";
import {Warning} from "@/plugins/warning";

export default {
  name: "page_link",
  components:{

  },
  data() {
    return {
      configObj:{},
      valueArr:{},
    }
  },
  computed: {

  },
  created() {
    this.getInfo()
  },
  mounted() {

  },
  methods: {
    addLink(val){
      this.valueArr[val].data.push(
          {"avatar":"","name_zh":"","name_en":"","school":"","position":""}
      )
    },
    del(key1,key2){
      this.valueArr[key1].data.splice(key2,1)
    },
    getInfo(){
      const requestData = {"key":"link_us"};
      getConfigInfo(requestData).then((res)=>{
        this.configObj = res.data;
        this.valueArr = res.data.valueObject;
      })
    },
    edit(){
      let val = JSON.stringify(this.valueArr);
      console.log(val)
      
      const requestData = {
        "key":this.configObj.key,
        "value": val,
      };

      editConfig(requestData).then(()=>{
        Warning.success("操作成功");
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.main-content-box{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  .main-content{
    width: 100%;
    border-radius: 30px;
    background: #fff;
    box-shadow: 0 15px 30px  rgba(0, 0, 0, .1);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    padding-bottom: 20px;
    margin-bottom: 45px;
    .main-title{
      font-size: 24px;
      font-weight: 600;
      color: #141414;
      margin-left: 30px;
      margin-top: 30px;
    }
    .main-btn{
      font-size: 24px;
      font-weight: 600;
      color: #141414;
      margin-right: 30px;
      margin-top: 30px;
      .btn-add{
        display: block;
        width: 100px;
        line-height: 48px;
        font-size: 21px;
        font-weight: 300;
        text-align: center;
        cursor: pointer;
        color: #fff;
        border-radius: 25px;
        background-color: #ba0704;
      }
    }
    .from{
      width: 100%;
      margin-left: 30px;
      margin-right: 30px;
      margin-bottom: 15px;
      border-collapse:separate;
      border-spacing:0px 30px;
      position: relative;
      .row{
        width: 100%;
        padding-top: 15px;
        padding-left: 15px;
        padding-right: 15px;
        .title{
          height: 40px;
          line-height: 40px;
          font-size: 18px;
          font-family: PingFang HK-Regular, PingFang HK;
          font-weight: 400;
          color: #000000;
          margin-bottom: 15px;
        }
        & > input{
          height: 50px;
          min-width: 500px;
          border-radius: 25px 25px 25px 25px;
          opacity: 1;
          border: 2px solid #DDD1B4;
          padding-left: 15px;
          padding-right: 15px;
        }
        & > textarea{
          height: 200px;
          min-width: 500px;
          border-radius: 25px 25px 25px 25px;
          opacity: 1;
          border: 2px solid #DDD1B4;
          padding: 15px;
        }
        .el-select{
          margin-right: 15px;
        }
        .address{
          margin-top: 15px;
          min-width: 600px;
        }
      }
      .thumb-box{
        width: 300px;
        height: 200px;
        position: absolute;
        top:0;
        right: 30px;
        label {
          display: block;
          width: 100%;
          height: 100%;
          & > img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            cursor: pointer;
            margin-top: 15px;
            border: 0.5px solid $blockColor--1;
          }
        }
      }
      .row-box{
        width: 33%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        float: left;
        position: relative;
        padding: 15px;
        border: 1px solid #DDD1B4;
        .title{
          height: 40px;
          line-height: 40px;
          font-size: 18px;
          font-family: PingFang HK-Regular, PingFang HK;
          font-weight: 400;
          color: #000000;
          margin-bottom: 15px;
        }
        .name{
          width: 100%;
        }
        .job{
          width: 100%;
        }
        .del{
          width: 18px;
          height: 23px;
          position: absolute;
          top: 25px;
          right: 35px;
          cursor: pointer;
        }
        & > input{
          height: 50px;
          width: 100%;
          border-radius: 25px 25px 25px 25px;
          opacity: 1;
          border: 2px solid #DDD1B4;
          padding-left: 15px;
          padding-right: 15px;
          margin-right: 30px;
        }
        & > textarea{
          height: 200px;
          width: 100%;
          border-radius: 25px 25px 25px 25px;
          opacity: 1;
          border: 2px solid #DDD1B4;
          padding: 15px;
        }
        .el-select{
          margin-right: 15px;
        }
        .address{
          margin-top: 15px;
          min-width: 600px;
        }
      }
      .btn-box{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 40px;
        padding-left: 15px;
        padding-right: 15px;
        .btn-confirm{
          display: block;
          width: 100%;
          line-height: 48px;
          font-size: 21px;
          font-weight: 300;
          text-align: center;
          cursor: pointer;
          color: #fff;
          border-radius: 25px;
          background-color: #ba0704;
        }
      }
    }
  }
  .btn-box{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 40px;
    .btn-confirm{
      display: block;
      width: 100%;
      line-height: 48px;
      font-size: 21px;
      font-weight: 300;
      text-align: center;
      cursor: pointer;
      color: #fff;
      border-radius: 25px;
      background-color: #ba0704;
    }
  }
}
</style>
